import React, { useEffect, useState } from "react";
import {
  dataDecrypt,
  encrypt,
} from "../../../../../app/utility/encryption-helper";
import { ApisService } from "../../../../../app/core/apis.service";
import { Form, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { TiHomeOutline } from "react-icons/ti";
import { CiLocationOn } from "react-icons/ci";
import { PiPhoneCallLight } from "react-icons/pi";

export const OnlineConnections = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [transactionsData, setTransactionsData] = useState<any>([]);
  const [originalConnectionData, setOriginalConnectionData] = useState<any>([]);
  const [connectionType, setConnectionType] = useState<string>("External");
  const [selectData, setSelectData] = useState<any>("");
  const [userDetails, setUserDetails] = useState<any>();

  useEffect(() => {
    loadOnlineConnections(connectionType);
    setSearchText("")
    getExternalBuData();
  }, [connectionType]);

  async function loadOnlineConnections(connectionType: any): Promise<void> {
    setLoading(true);
    if (connectionType === "External") {
      externalConnections();
    } else {
      internalConnections();
    }
  }

  async function getExternalBuData(): Promise<void> {
    setLoading(true);
    try {
      let payload = {
        id: params.org,
      };
      let encryptedData = encrypt(JSON.stringify(payload));
      const apiRes = await ApisService.getOrganizationData("findById", encryptedData);
      const buData = JSON.parse(dataDecrypt(apiRes.data.data));
      setUserDetails(buData[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function externalConnections(): Promise<void> {
    setLoading(true);
    try {
      let payload = {
        buId: params.org,
        filters: { bu_name: null, contactNumber: null },
      };
      let encryptedData = encrypt(JSON.stringify(payload));
      const res = await ApisService.createInvitation(
        "findAllConnections",
        encryptedData
      );
      const transactionsData = JSON.parse(dataDecrypt(res.data.data));
      setTransactionsData(transactionsData.results);
      setOriginalConnectionData(transactionsData.results);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function internalConnections(): Promise<void> {
    setLoading(true);
    try {
      let payload = {
        id: userDetails?.user_id,
        filters: { bu_name: null, contactNumber: null },
      };
      let encryptedData = encrypt(JSON.stringify(payload));
      const res = await ApisService.getOrganizationData(
        "findOrgByUser_v2",
        encryptedData
      );
      const transactionsData = JSON.parse(dataDecrypt(res.data.data));
      setOriginalConnectionData(transactionsData);
      setTransactionsData(transactionsData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const handleInput = (value: string) => {
    setSearchText(value);
    if (value.trim() === "") {
      setTransactionsData(originalConnectionData);
    } else {
      const filtered = originalConnectionData.filter(
        (item: any) =>
          item?.bu_name?.toLowerCase().includes(value?.toLowerCase()) ||
          item?.business_name?.toLowerCase().includes(value?.toLowerCase())
      );
      setTransactionsData(filtered);
    }
  };

  const handleConnectionTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setConnectionType(event.target.value);
  };

  const getConnectionData = (data: any) => {
    if (connectionType === "External") {
      setSelectData(data);
      setShow(true);
    } else {
      navigate(
        `/dashboard/organizations/org-details/${params.page}/${params.org}/online-connections/${data?.id}/${data?.business_name}/view`
      );
    }
  };

  const closePopup = () => {
    setShow(false);
    setSelectData(false);
  }

  const navigateViewScreen = () => {
    setShow(false);
    navigate(`/dashboard/organizations/org-details/${params.page}/${params.org}/online-connections/${selectData?.bu_id}/${selectData?.bu_name}/view`);
  }

  const navigateTransactionScreen = () => {
    setShow(false);
    navigate(`/dashboard/organizations/org-details/${params.page}/${params.org}/online-connections/${selectData?.bu_id}/${selectData?.bu_name}/transaction`);
  }

  return (
    <div className="">
      <div className="row">
        <div className="col-md-4 my-3">
          <input
            type="search"
            className="form-control p-2"
            placeholder="Search"
            value={searchText}
            onChange={(e) => handleInput(e.target.value)}
          />
        </div>
        <div className="col-md-4"></div>
        <div className="col-md-4 my-3">
          <Form.Select
            aria-label="Default select example"
            value={connectionType}
            onChange={handleConnectionTypeChange}
          >
            <option value="External">External</option>
            <option value="Internal">Internal</option>
          </Form.Select>
        </div>
      </div>
      <div className="col-12 px-0 my-2">
        {loading && (
          <div className="text-center p-5">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        )}
       {!loading && (
  <div className="row">
    {Array.isArray(transactionsData) &&
      transactionsData.length > 0 &&
      transactionsData.map((value: any, index: number) => (
        <div className="col-md-4 d-flex mb-1" key={index}>
          <div
            className="card mb-2 cursor-pointer h-100 w-100 lh-1"
            onClick={() => getConnectionData(value)}
          >
            <div className="card-body border-0 box-shadow py-2">
              <div className="d-flex align-items-center">
                <TiHomeOutline size={20} />
                <span className="ms-2 fs-14 fw-600 mt-1">
                  {value?.bu_name} {value?.business_name}
                </span>
              </div>

              <div className="d-flex align-items-center py-1">
                <CiLocationOn size={20} />
                <span className="ms-2 fs-14 fw-500 mt-1">
                  {value?.city}
                </span>
              </div>

              <div className="d-flex align-items-center">
                <PiPhoneCallLight size={20} />
                <span className="ms-2 fs-14 fw-500 mt-1">
                  {value?.contact_number}
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
  </div>
)}
        {!loading && !transactionsData && <h6 className="text-center">No data found</h6>}
      </div>
      <Modal show={show} centered onHide={closePopup}>
        <Modal.Body>
          <button className="w-100 mb-2 rounded py-2 box-shadow grey-border hover-item" onClick={() => navigateViewScreen()}>View Details</button>
          <button className="w-100 rounded py-2 box-shadow grey-border hover-item mb-2" onClick={() => navigateTransactionScreen()}>Transaction History</button>
          <button className="w-100 rounded py-2 box-shadow grey-border hover-item" onClick={() => closePopup()}>Close</button>
        </Modal.Body>
      </Modal>
    </div>
  );
};
